import { IContainer } from '../../interface/container';
import { bindUserAlert } from './interface';
import { setupStore } from './store';
import alert from './main';

function binder(container: IContainer) {
    setupStore();
    bindUserAlert(alert(), container);
}

export default binder;
